import React from 'react';

import Form from './Form';

export default props => (
  <Form
    predicate={props.predicate}
    before={props.before}
    after={props.after}
    submitLabel={props.submitLabel}
    page={props.page} 
    token={props.token}
    mseller={props.mseller}
    showForgotPassword={props.showForgotPassword}
  />
);
